var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"headway"},[_c('span',[_c('i',{class:['ra-icon--bell', { active: _vm.widgetActive }]})])])
}
var staticRenderFns = []

export { render, staticRenderFns }